export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/check.8b4c905a.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};